import { request } from "./api";

/** Full GET /config response body (both exists true/false shapes). */
export const TENANT_CONFIG_STORAGE_KEY = "hrms_tenant_config";

/** True when running on localhost (local dev / testing). */
export function isLocalDevHost() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname.toLowerCase();
  return host === "localhost" || host === "127.0.0.1";
}

export function readStoredTenantConfig() {
  try {
    const raw = localStorage.getItem(TENANT_CONFIG_STORAGE_KEY);
    if (raw == null) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearStoredTenantConfig() {
  try {
    localStorage.removeItem(TENANT_CONFIG_STORAGE_KEY);
  } catch {
    // ignore
  }
}

let inflightPromise = null;

/**
 * Returns tenant config from localStorage if present; otherwise GET /config once,
 * persists the full JSON body, and returns it. Concurrent callers share one request
 * (Strict Mode / double mount safe).
 */
export async function getPublicTenantConfig() {
  if (typeof window === "undefined") return null;

  const cached = readStoredTenantConfig();
  if (cached !== null) {
    // Drop stale "tenant not found" cache from before localhost bypass was enabled
    if (isLocalDevHost() && cached?.result?.exists === false) {
      clearStoredTenantConfig();
    } else {
      return cached;
    }
  }

  if (inflightPromise) return inflightPromise;

  inflightPromise = (async () => {
    try {
      const data = await request("/config", { method: "GET", skipAuth: true });
      localStorage.setItem(TENANT_CONFIG_STORAGE_KEY, JSON.stringify(data));
      return data;
    } finally {
      inflightPromise = null;
    }
  })();

  return inflightPromise;
}
